<template>
  <div class="autorizacao">
    <div class="mb-2" style="text-align: right">
      <v-btn color="cyan" small dark to="/autorizacao-diario/novo" class="rounded-sm font-weight-regular" width="90px">Novo</v-btn>
    </div>

  <v-alert type="error" v-if="$v.filtros.$invalid && $v.filtros.$dirty" :value="true" color="error">
    <div>Atenção: Verifique os campos obrigatórios, antes de iniciar a busca.</div>
  </v-alert>

  <v-alert type="error"  style="color: white;" v-if="filtros.noResult && filtros.loading == false" :value="true">
      <div>Nenhuma autorização cadastrada!</div>
  </v-alert>
    <v-alert v-if="filtros.loading" :value="true" color="info" icon="info" >
    <div class="white--text">Por favor aguarde, estamos realizando a busca...</div>
  </v-alert>
  <br />

    <form @submit.prevent="handleSearch">
        <v-layout row wrap>
              <v-flex xs-12 md-1>
                <Input style="width: 95%;" type="text" label="Ano letivo" :v="$v.filtros.aaletivo"  v-model.trim="filtros.aaletivo" @blur="setPeriodo()" />
              </v-flex>
              <v-flex xs-12 md-2>
                <InputDate style="width: 95%;" label="Dt Abertura" :v="$v.filtros.dataaberturadiario" v-model.trim="filtros.dataaberturadiario"/>
              </v-flex>
              <v-flex xs-12 md-2>
                <InputDate style="width: 95%;" label="Dt Fechamento"  :v="$v.filtros.datafechamentodiario" v-model.trim="filtros.datafechamentodiario"/>
              </v-flex>
              <v-flex xs12 md3>
                <Select style="width: 98%;" :label="`Nível Ensino* (${ optionsNivelEnsino.length == 0 ?  optionsNivelEnsino.length : optionsNivelEnsino.length - 1 })`" v-model="filtros.cdinstruc" :options="optionsNivelEnsino" :v="$v.filtros.cdinstruc"  @change="changeNivelDeEnsino"/>
              </v-flex>
              <v-flex xs12 md3>
                <Select style="width: 98%;" :label="`Período Avaliativo* (${ optionsPeriodo.length == 0 ?  optionsPeriodo.length : optionsPeriodo.length - 1 })`" :options="optionsPeriodo" v-model="filtros.cdpravadi" :v="$v.filtros.cdpravadi" />
              </v-flex>
              <v-flex xs12 md4>
                <Select :disabled="filtros.cdpravadi == ''" style="width: 98%;" :label="`Etapa Escola (${ optionsEtapaEscolar.length == 0 ?  optionsEtapaEscolar.length : optionsEtapaEscolar.length - 1 })`" v-model="filtros.cdserie" :options="optionsEtapaEscolar"   @focus="loadEtapaEscolar"/>
              </v-flex>
              <v-flex xs12 md4>
                <Select :disabled="filtros.cdpravadi == ''" style="width: 98%;" :label="`Escola (${ optionsEscola.length == 0 ?  optionsEscola.length : optionsEscola.length - 1 })`" v-model="escolaSelected" :options="optionsEscola"  @focus="loadEscola" />
              </v-flex>
              <v-flex xs12 md4>
                <Select :disabled="filtros.cdpravadi == ''" style="width: 98%;" :label="`Professor (${ optionsProfessor.length == 0 ?  optionsProfessor.length : optionsProfessor.length - 1 })`" v-model="professorSelected" :options="optionsProfessor"  @focus="loadProfessor"  />
              </v-flex>
              <v-flex xs12 md4>
                <Select :disabled="filtros.cdpravadi == ''" style="width: 98%;" :label="`Turma (${ optionsTurma.length == 0 ?  optionsTurma.length : optionsTurma.length - 1 })`" :options="optionsTurma" v-model="filtros.cdturma"  @focus="loadTurma" />
              </v-flex>
              <v-flex xs12 md4>
                <Select :disabled="filtros.cdpravadi == ''" style="width: 98%;" :label="`Disciplina (${ optionsDisciplina.length == 0 ?  optionsDisciplina.length : optionsDisciplina.length - 1 })`" :options="optionsDisciplina" v-model.number="filtros.cddiscipl"  @focus="loadDisciplina" />
              </v-flex>

              <!-- <pre>
              {{ $v }}
              </pre> -->

              <v-flex xs12 md12>
                <v-btn :loading="filtros.loading" small type="submit" color="cyan" dark class="rounded-sm font-weight-regular" width="90px">Buscar</v-btn>
              </v-flex>

              <!-- <pre>
                {{ filtros }}
              </pre> -->
          </v-layout>
      </form>

      <br />
      <div class="filtro-bloco-busca  v-card "  v-if="!filtros.loading">
          <div class="filtro-itens">
            <div>
              <pre>

              </pre>
              <strong>Ano letivo: * </strong>
              <span>{{ filtros.aaletivo }} </span><br />
              <strong>Período: *</strong> {{ filtros.dataaberturadiario  | formatDataBR }} <strong>até</strong>  {{ filtros.datafechamentodiario  | formatDataBR }} <br />
              <strong>Nível de Ensino: * </strong>
              <span>{{ filtros.cdinstruc == '' ? 'Todos' : getLabelFiltro(optionsNivelEnsino, this.filtros.cdinstruc) }} </span><br />
              <strong>Período Avaliativo: * </strong>
              <span>{{ filtros.cdpravadi == '' ? 'Todos' : getLabelFiltro(optionsPeriodo, this.filtros.cdpravadi) }} </span><br />
              <strong>Etapa Escolar: </strong>
              <span>{{ filtros.cdserie == '' ? 'Todas' : getLabelFiltro(optionsEtapaEscolar, this.filtros.cdserie) }} </span><br />
              <strong>Escola: </strong>
              <span>{{ escolaSelected == '' ? 'Todas' : JSON.parse(escolaSelected)['nmescola'] }} </span><br />
              <strong>Professor: </strong>
              <span>{{ professorSelected == '' ? 'Todos' : JSON.parse(professorSelected)['nmfuncion'] }} </span><br />
              <strong>Turma: </strong>
              <span>{{ filtros.cdturma == '' ? 'Todas' : getLabelFiltro(optionsTurma, this.filtros.cdturma) }} </span><br />
              <strong>Disciplina: </strong>
              <span>{{ filtros.cddiscipl == '' ? 'Todas' : getLabelFiltro(optionsDisciplina, this.filtros.cddiscipl) }} </span><br />
            </div>
          </div>
          <div>
            <strong>Resultados Encontrados:</strong> {{ paginaTotal }}
          </div>
        </div>

      <br />
      <!-- <pre>
        {{ escolaSelected }}
      </pre> -->




    <v-card style="overflow-y: auto">
      <table class="table-siged">
        <thead>
          <tr>

            <th>Ano Letivo</th>
            <th>Período Avaliativo</th>
            <th>Nível Ensino</th>
            <th>Etapa Escolar</th>
            <th>Escola</th>
            <th>Professor</th>
            <th>Turma</th>
            <th>Disciplina</th>
            <th>Data Abertura</th>
            <th>Data Fechamento</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="auto in autorizacoes" :key="auto.identificadorautorizacaodiarioprof">
            <td class="centro">{{ auto.aaletivo }}</td>
            <td class="centro">{{ auto.periodo_avaliativo ? auto.periodo_avaliativo.dspravadi : '' }}</td>
            <td class="centro">{{ auto.nivel ? auto.nivel.dsinstruc : '' }}</td>
            <td class="centro">{{ auto.etapa_escolar ? auto.etapa_escolar.dsserie : '' }}</td>
            <td>{{ auto.escola? auto.escola.nmescola : '' }}</td>
            <td class="centro">{{ auto.professor? auto.professor.nmfuncion : '' }}</td>
            <td class="centro">{{ auto.turma? auto.turma.nmturma : '' }}</td>
            <td class="centro">{{ auto.disciplina? auto.disciplina.dsdiscipl : '' }}</td>
            <td class="centro">{{ auto.dataaberturadiario | formatDataBR }}</td>
            <td class="centro">{{ auto.datafechamentodiario | formatDataBR }}</td>
            <td class="centro">
              <v-btn icon title="Editar" class="aulas-btn-acao" :to="{ path: `/autorizacao-diario/${auto.identificadorautorizacaodiarioprof}` }">
                <v-icon class="btn-acoes-icon">edit</v-icon>
              </v-btn>
              <v-btn icon title="Excluir" class="aulas-btn-acao" @click="excluir(auto.identificadorautorizacaodiarioprof)">
                <v-icon color="red">delete_forever</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="quantidadePaginas > 1" class="table-siged-page" style="text-align: right">
        <v-pagination v-model="paginaAtual" :length="quantidadePaginas" total-visible="7" />
      </div>
    </v-card>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import { required, minLength, maxLength, integer } from 'vuelidate/lib/validators';
import SelectBuscaApi from '@/components/SelectBuscaApi'
import api from '@/api'
import moment from 'moment';
const AutorizacaoDiarioRepository = RepositoryFactory.get('autorizacaoDiario');


export default {
  name: 'AutorizacaoDiario',
  // components: {
  //   SelectBuscaApi
  // },
  data() {
    return {
      loadingGeral: false,
      loadingEtapaEscolar: false,
      loadingEscola: false,
      loadingProfessor: false,
      loadingTurma: false,
      loadingDisciplina: false,
      filtros: {
        loading: false,
        noResult: false,
        aaletivo: new Date().getFullYear(),
        minDate: `${new Date().getFullYear()}-01-01`,
        // dataaberturadiario: `${new Date().getFullYear()}-01-01`,
        dataaberturadiario: `01/01/${new Date().getFullYear()}`,
        // datafechamentodiario: `${new Date().getFullYear()}-12-31`,
        datafechamentodiario: `31/12/${new Date().getFullYear()}`,
        cdinstruc: "",
        dsinstruc: "",
        cdpravadi: "",
        dspravadi: "",
        cdserie: "",
        dsserie: "",
        cdescola: "",
        cdtipesc: "",
        nmescola: "",
        cdpessoal: "",
        cdmatric: "",
        nmfuncion: "",
        cdturma: "",
        nmturma: "",
        cddiscipl: "",
        dsdiscipl: "",
      },
      escolaSelected: '',
      professorSelected: '',
      // defaultSelectNivelEnsino: {cdinstruc: "", dsinstruc: ""},
      // defaultSelectPeriodoAvaliativo: {cdpravadi: "", dspravadi: ""},
      // defaultSelectEtapaEscolar: {cdserie: "", dsserie: ""},
      // defaultSelectEscola: {cdescola: "", nmescola: "", cdtipesc: ""},
      // defaultSelectProfessor: {cdmatric: "", nmfuncion: ""},
      // defaultSelectTurma: {cdturma: "", nmturma: ""},
      // defaultSelectDisciplina: {cddiscipl: "", dsdiscipl: ""},
      autorizacoes: [],
      paginaAtual: 1,
      paginaTotal: 0,
      filtroBusca: [],
      quantidadePaginas: 0,
      snackbar: false,
      submitText: '',
      optionsNivelEnsino: [],
      optionsEtapaEscolar: [],
      optionsEscola: [],
      optionsProfessor: [],
      optionsTurma: [],
      optionsDisciplina: [],
      optionsPeriodo: []

    };
  },
  validations: {
    filtros: {
        aaletivo: { required, minLength: minLength(4), maxLength: maxLength(4) },
        dataaberturadiario: { required, isValidDate: (value) => moment(value, 'DD/MM/YYYY').isValid() },
        datafechamentodiario: { required, isValidDate: (value) => moment(value, 'DD/MM/YYYY').isValid() },
        cdinstruc: { required },
        cdpravadi: { required },

    },
  },
  watch: {
    paginaAtual() {
      this.handleSearch(this.paginaAtual);
    }
  },
  created() {
    this.autorizacoes = [];
    // console.log(this.$refs);
    // this.$refs.selectBuscaApiNivelEnsino.handleSearch();
  },
  async beforeRouteEnter(to, from, next){
    // const { data } = await AutorizacaoDiarioRepository.getListaAutorizacao();
    next(vm => vm.reload());
    next(vm => null);
  },
  methods: {
    getLabelFiltro(lista, fieldValue){

      const item = lista.find(item => item.value == fieldValue);

      if(item) {
        return item.text;
      }

      return '';
    },
    getFiltros() {
      const {cdescola , cdtipesc} = (this.escolaSelected) ? JSON.parse(this.escolaSelected) : {};
      const {cdpessoal , cdmatric} = (this.professorSelected) ? JSON.parse(this.professorSelected) : {};
      this.filtros = {...this.filtros, cdescola, cdtipesc, cdpessoal, cdmatric};
      // this.filtros.cdtipesc = this.escolaSelected.cdtipesc;
      // this.filtros.cdescola = this.escolaSelected.cdescola;
      // this.filtros.cdpessoal = this.escolaSelected.cdpessoal;
      // this.filtros.cdmatric = this.escolaSelected.cdmatric;
      // debugger
      return this.filtros;
    },
    setPeriodo() {
      if(this.filtros && this.filtros.aaletivo.length >= 4) {
      // this.filtros.minDate = `${this.filtros.aaletivo}-01-01`;
      this.filtros.minDate = `01/01/${this.filtros.aaletivo}`;
      // this.filtros.dataaberturadiario = `${this.filtros.aaletivo}-01-01`;
      this.filtros.dataaberturadiario = `01/01/${this.filtros.aaletivo}`;
      // this.filtros.datafechamentodiario = `${this.filtros.aaletivo}-12-31`;
      this.filtros.datafechamentodiario = `31/12/${this.filtros.aaletivo}`;
      this.loadNivelDeEnsino()
      }
    },
    async changeNivelDeEnsino() {
      this.filtros.cdpravadi= '';
      this.filtros.dspravadi= '';
      this.filtros.cdserie= '';
      this.filtros.dsserie= '';
      this.escolaSelected = '';
      this.filtros.cdescola= '';
      this.filtros.cdtipesc= '';
      this.filtros.nmescola= '';
      this.professorSelected = '';
      this.filtros.cdpessoal = '';
      this.filtros.cdmatric= '';
      this.filtros.nmfuncion= '';
      this.filtros.cdturma= '';
      this.filtros.nmturma= '';
      this.filtros.cddiscipl= '';
      this.filtros.dsdiscipl= '';
      this.optionsPeriodo = [];
      this.optionsEtapaEscolar = [];
      this.optionsEscola = [];
      this.optionsProfessor = [];
      this.optionsTurma = [];
      this.optionsDisciplina = [];
      await this.loadPeriodoAvaliativo();

    },
    async changePeriodoAvaliativo() {
      this.filtros.cdserie= '';
      this.filtros.dsserie= '';
      this.escolaSelected = '';
      this.filtros.cdescola= '';
      this.filtros.cdtipesc= '';
      this.filtros.nmescola= '';

      this.professorSelected = '';
      this.filtros.cdpessoal = '';
      this.filtros.cdmatric= '';
      this.filtros.nmfuncion= '';
      this.filtros.cdturma= '';
      this.filtros.nmturma= '';
      this.filtros.cddiscipl= '';
      this.filtros.dsdiscipl= '';
      this.optionsEtapaEscolar = [];
      this.optionsEscola = [];
      this.optionsProfessor = [];
      this.optionsTurma = [];
      this.optionsDisciplina = [];
    },
    async loadNivelDeEnsino() {
      try{
        this.loadingGeral = true;
        const { data } = await api.get(`ei/nivelensino/${this.filtros.aaletivo}`)

        this.optionsNivelEnsino = data.results.map(key => ({ value: key.cdinstruc, text: `${key.cdinstruc} - ${key.dsinstruc}` }));
        this.optionsNivelEnsino.unshift({ value: '{}', text: '' });
      } finally {
        this.loadingGeral = false;
      }
    },
    async loadPeriodoAvaliativo() {
      try{
        this.loadingGeral = true;

        const params = {
          aaletivo: this.filtros.aaletivo,
          cdinstruc: this.filtros.cdinstruc
        };

        const { data } = await api.get('ei/periodo-avaliativo/getPeriodoAvaliativoPorNivelDeEnsino', {
                                      params,
                                      });

        this.optionsPeriodo = data.results.map(key => ({ value: key.cdpravadi, text: `${key.dspravadi}` }));
        this.optionsPeriodo.unshift({ value: '', text: '' });
      } finally {
        this.loadingGeral = false;
      }
    },
    async loadEtapaEscolar() {
      if(this.loadingEtapaEscolar || this.loadingGeral) return;
      try{
        this.loadingGeral =  true;
        this.loadingEtapaEscolar = true;

        const { data } = await api.get('ei/etapaescolar/getEtapaEscolarPorDescricao', {
                                      params: this.getFiltros(),
                                      });

        this.optionsEtapaEscolar = data.results.map(key => ({ value: key.cdserie, text: `${key.dsserie}` }));
        this.optionsEtapaEscolar.unshift({ value: '', text: 'Todas' });
      } finally {
        this.loadingGeral =  false;
        this.loadingEtapaEscolar = false;
      }
    },
    async loadEscola() {
      if(this.loadingEscola || this.loadingGeral) return;
      try{
        this.loadingGeral =  true;
        this.loadingEscola = true;

        const { data } = await api.get('ei/escola/getEscolaPorNome', {
                                      params: this.getFiltros(),
                                      });

        this.optionsEscola = data.results.map(key => ({ value: JSON.stringify({ cdtipesc: parseInt(key.cdtipesc), cdescola: parseInt(key.cdescola), nmescola:  key.nmescola }), text: key.nmescola }));
        this.optionsEscola.unshift({ value: '', text: 'Todas' });
      } finally {
        this.loadingGeral =  false;
        this.loadingEscola = false;
      }
    },
    async loadProfessor() {
      if(this.loadingProfessor || this.loadingGeral) return;
      try{
        this.loadingGeral =  true;
        this.loadingProfessor = true;

        const { data } = await api.get('ei/professor/getProfessorPorNome', {
                                      params: this.getFiltros(),
                                      });

        this.optionsProfessor = data.results.map(key => ({ value: JSON.stringify({ cdpessoal: parseInt(key.cdpessoal), cdmatric: parseInt(key.cdmatric), nmfuncion: key.nmfuncion }), text: key.nmfuncion }));
        this.optionsProfessor.unshift({ value: '', text: 'Todas' });
      } finally {
        this.loadingGeral =  false;
        this.loadingProfessor = false;
      }
    },
    async loadTurma() {
      if(this.loadingTurma || this.loadingGeral) return;
      try{
        this.loadingGeral =  true;
        this.loadingTurma = true;
        const { data } = await api.get('ei/turma/getTurmaPorNome', {
                                      params: this.getFiltros(),
                                      });

        this.optionsTurma = data.results.map(key => ({ text: `${key.nmturma} - ${key.horario}`, value: key.cdturma }));
        this.optionsTurma.unshift({ value: '', text: 'Todas' });
      } finally {
        this.loadingGeral =  false;
        this.loadingTurma = false;
      }
    },
    async loadDisciplina() {
      if(this.loadingDisciplina || this.loadingGeral) return;
      try {
        this.loadingGeral =  true;
        this.loadingDisciplina = true;
        const { data } = await api.get('ei/disciplina/getDisciplinaPorNome', {
                                      params: this.getFiltros(),
                                      });

        this.optionsDisciplina = data.results.map(key => ({ text: key.dsdiscipl, value: key.cddiscipl }));
        this.optionsDisciplina.unshift({ value: '', text: 'Todas' });

      } finally {
        this.loadingGeral =  false;
        this.loadingDisciplina = false;
      }
    },
    handleItemSelecionado(item){
        const keys = Object.keys(this.filtros);

          keys.forEach(key => {
            if(key in item) {
              this.filtros[key] = item[key];
            }
          });

        if(Object.keys(item).includes('cdinstruc')) {


          this.filtros.cdpravadi = "";
          this.filtros.dspravadi = "Todos";
          this.filtros.cdserie = "";
          this.filtros.dsserie = "Todos";
          this.filtros.cdescola = "";
          this.filtros.cdtipesc = "";
          this.filtros.nmescola = "Todas";
          this.filtros.cdmatric = "";
          this.filtros.nmfuncion = "Todos";
          this.filtros.cdturma = "";
          this.filtros.nmturma = "Todas";
          this.filtros.cddiscipl = "";
          this.filtros.dsdiscipl = "Todas";
       }

      // console.log(this.filtros);

    },
    async handleSearch(page = 1) {


      try{
        // console.log(this.$v);
        this.$v.$touch();
        if (this.$v.$invalid) { return; }

        this.filtros.loading = true;
        this.autorizacoes = [];
        this.$Progress.start();
        const params = {
          page,
          ...this.filtros,
          dataaberturadiario: moment(this.filtros.dataaberturadiario, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          datafechamentodiario: moment(this.filtros.datafechamentodiario, 'DD/MM/YYYY').format('YYYY-MM-DD')
        };

        const response = await api.get('/ei/autorizacao-diario', {
          params
        });
      const  data = response.data;
      this.paginaAtual = data.results.current_page;
      this.autorizacoes = data.results.data;
      this.quantidadePaginas = data.results.last_page;
      this.paginaTotal = data.results.total;

      this.$Progress.finish();
      this.filtros.loading = false;
      this.autorizacoes.length ? this.filtros.noResult = false : this.filtros.noResult = true;



      }catch(error) {
        // console.log("erro:", error);
        this.$Progress.finish();
        this.filtros.loading = false;
      }


    },
    async reload(data = null) {
      // if(!data) {
      //   this.$Progress.start();
      //   const retorno = await AutorizacaoDiarioRepository.getListaAutorizacao({ page: this.paginaAtual, ...this.filtroBusca });
      //   data = retorno.data;
      // }
      // this.paginaAtual = data.results.current_page;
      // this.autorizacoes = data.results.data;
      // this.quantidadePaginas = data.results.last_page;
      // this.paginaTotal = data.results.total;
      this.loadNivelDeEnsino();
      this.$Progress.finish();
    },
    // async filtroRegistros(data) {
    //   this.paginaAtual = 1;
    //   this.$refs.filtro.exibirFiltro = false;
    //   this.filtroBusca = data.filtro;
    //   // await this.reload();
    //   await this.handleSearch();
    //   this.$refs.filtro.exibirFiltro = data.exibir;
    // },
    async excluir(id) {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir esta autorização?',
        type: 'warning',
        buttons: [
          { text: 'Excluir', color: 'red', response: true },
          { text: 'Cancelar', color: 'grey', response: false },
        ],
      });
      if(!confirmar) { return; }

      try {
        const { data } = await AutorizacaoDiarioRepository.deleteAutorizacao(id);

        this.submitText = data.message;
        this.snackbar = true;
        if(this.paginaAtual > 1 && this.telas.length == 1) { this.paginaAtual--; }
        // this.reload();
        // await this.handleSearch();
        this.autorizacoes = this.autorizacoes.filter(item => item.identificadorautorizacaodiarioprof  !== id);
      }catch(error) {
        if(error.response) {
          this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }
    },
  },
}
</script>

<style lang="scss">
.autorizacao {
  margin: 0px 15px;
}

.filtro-bloco-busca {
    border: 1px solid '#99999';
    background: white;
    padding: 20px;
    border-radius: 4px;
    font-size: 16px;

    .filtro-itens {
      display: flex;
      flex-wrap: wrap;
      div {
        min-width: 300px;
        margin-right: 10px;
      }
    }
  }
</style>
